<script>
// @ts-check
import ReportsFilter from '@views/chart/reports-filter'
import ReportsSingleFilter from '@views/chart/reports-filter-single'
import ReportsMetrics from '@views/chart/reports-metrics'
import ReportsSingleMetric from '@views/chart/reports-metric-single'
import ChartIntroComponents from '@components/chartIntros'
import Loading from '@components/custom-loading'
import HighCharts from 'highcharts'
import * as R from 'ramda'
import axios from 'axios'
import qs from 'qs'
import _map from 'lodash/map'
import _forEach from 'lodash/forEach'
import _reduce from 'lodash/reduce'
import { mapState, mapGetters } from 'vuex'
import { Maybe, ChartSelections, Wizard, Metrics } from '@domain' // eslint-disable-line

var primaryChartHeight = 600
var seriesDataIds = []
var reportChart = {}
let regionMapName = [
  'Region 01 – Edinburg',
  'Region 02 – Corpus Christi',
  'Region 03 – Victoria',
  'Region 04 – Houston',
  'Region 05 – Beaumont',
  'Region 06 – Huntsville',
  'Region 07 – Kilgore',
  'Region 08 – Mount Pleasant',
  'Region 09 – Wichita Falls',
  'Region 10 – Richardson',
  'Region 11 – Fort Worth',
  'Region 12 – Waco',
  'Region 13 – Austin',
  'Region 14 – Abilene',
  'Region 15 – San Angelo',
  'Region 16 – Amarillo',
  'Region 17 – Lubbock',
  'Region 18 – Midland',
  'Region 19 – El Paso',
  'Region 20 – San Antonio',
]

function drawChartInfoOnFoot(chart, that) {
  let preparedData = that.preparedData
  primaryChartHeight = chart.chartHeight
  chart.chartFooter = chart.renderer.g('chartFooter').add()
  chart.renderer
    .label(
      preparedData.SubTitle +
        that.demographicsOnFooter() +
        '</b>' +
        that.categoriesOnFooter +
        '<br/>Source: <b>' +
        preparedData.schoolYear +
        ' TAPR*</b><br>' +
        '<br>Data displayed as N/A is either not available or the category has fewer than 5 students and must be reflected as N/A to comply with FERPA regulations.' +
        '<br>Sorted A to Z<br/>',
      50,
      chart.chartHeight - 80,
      'rect',
      'rect',
      0,
      0,
      true
    )  // TAPR tooltip
    .on('mouseover', function () {
      document.querySelector('#TAPR').style.visibility = "visible";
    })

    .on('mouseout', function () {

      document.querySelector('#TAPR').style.visibility = "hidden";
    })
    .css({
      width: chart.chartWidth + 'px',
    })
    .add(chart.chartFooter)

}


function refreshDataLabels() {
  setTimeout(function() {
    R.forEach(v => {
      v.style.opacity = 1
    }, document.querySelectorAll('.highcharts-data-labels'))
  }, 800)

  R.forEach(v => {
    v.style.opacity = 1
  }, document.querySelectorAll('.highcharts-data-label'))
}

function setChartSize(chart, that) {
  var barWidth = 14
  var barGap = 2
  var groupGap = 26
  var categories = chart.xAxis[0].categories.length
  var barsPerCategory = _reduce(
    that.demographicOptions,
    (sum, value) => {
      return value.checked ? sum + 1 : sum
    },
    0
  )
  barsPerCategory = barsPerCategory > 5 ? barsPerCategory : 5
  chart.setSize(
    chart.chartWidth,
    categories * groupGap +
      categories * barsPerCategory * (barWidth + barGap) +
      chart.margin[0] +
      chart.margin[2]
  )
  chart.chartFooter.translate(0, chart.chartHeight - primaryChartHeight)

  refreshDataLabels()
}

function initEventOfCustomLegend(chart, that) {
  var filterCustomItems = document.querySelectorAll(
    '.multi-checkboxes .custom-checkbox'
  )
  function simulateLegendItemClick(e) {
    var dataId = e.target.parentElement.attributes['data-id']
    if (!dataId) {
      return
    }
    var series = chart.get(dataId.value)
    series.setVisible(!series.visible)

    if (reportChart && reportChart.update) {
      let newSeries = []
      R.map(s => {
        let obj = { name: s.name, data: s.yData, visible: s.visible }
        newSeries.push(obj)
      }, chart.series)
      reportChart.update(
        {
          series: newSeries,
        },
        true,
        true,
        false
      )
    }

    setChartSize(chart, that)
  }
  _forEach(filterCustomItems, item => {
    item.addEventListener('click', simulateLegendItemClick)
  })
}

function defaultSelect(chart) {
  R.forEach(s => {
    s.setVisible(s.name === 'All Students')
  }, chart.series)
}

async function getChartData(searchOption, requestUrl) {

  try {
    const res = await axios({
      method: 'post',
      url: requestUrl,
      data: qs.stringify(searchOption),
    }).then(response => {
      // console.log(requestUrl);
      // console.log(response.data.metricDatas.length);
      if (response.data.metricDatas.length > 0) {
        response.data.metricDatas = R.map(r => {
          r.regions = R.map(v => {
            v.name = regionMapName[parseFloat(v.id) - 1]
            return v
          }, r.regions)
          return r
        }, response.data.metricDatas)
      }
      return response.data
    })
    return res
  } catch (error) {
    throw error
  }
}


export default {
  page: {
    title: 'Reports',
    meta: [{ name: 'description', content: 'reports page...' }],
  },
  components: {
    ReportsFilter,
    ReportsSingleFilter,
    ReportsMetrics,
    ReportsSingleMetric,
    Loading,
    ...ChartIntroComponents,
  },
  data() {
    return {
      responseData: {},
      preparedData: {},
      isRenderingChart: false,
      years: [],
      selectedYears: '',
      defaultDemographic: 'All Students',
      demographicsMap: [
        // web presentation
        'All Students',
        'African American',
        'American Indian',
        'Asian',
        'Hispanic',
        'Pacific Islander',
        'Two or More Races',
        'White',
        'English Language Learners',
        'At-Risk',
        'Female',
        'Male',
        'Low-income',
      ],
      demographics: [
        'All Students',
        'African American/Black',
        'American Indian',
        'Asian',
        'Hispanic',
        'Native Hawaiian/Pacific Islander',
        'Two or More Races',
        'White',
        'English Language Learners',
        'At Risk',
        'Female',
        'Male',
        'Low Income',
      ],
      metrics: [],
      colors: [
        '#EB4724',
        '#D81671',
        '#51BC81',
        '#11A0B0',
        '#FFB12F',
        '#0892C5',
        '#969696',
        '#46AA96',
        '#6BAED6',
        '#A03764',
        '#642D8C',
        '#12575C',
        '#0E3594',
      ],
    }
  },
  computed: {
    demographicOptions() {
      return _map(this.demographics, (val, index) => {
        return {
          label: val,
          id: 'filter-item-' + index,
          checked: val === 'All Students',
        }
      })
    },
    categoriesOnFooter() {
      if (this.selectedMetrics.length === 0) {
        return ''
      } else if (this.selectedMetrics.length === 1) {
        return '<br/>Category: <b>' + this.selectedMetrics[0] + '</b>'
      } else {
        let html = '<br/>Categories: '
        let that = this
        R.forEach(v => {
          let index = R.findIndex(m => m.label === v.label, that.metrics)
          html +=
            '<span style="font-weight:bold;color: ' +
            that.colors[index] +
            ';">' +
            v.label +
            '</span>, '
        }, R.filter(m => m.checked, this.metrics))
        return R.slice(0, -2, html)
      }
    },
    metricsOptions() {
      return this.metricsRange ? this.metricsRange[0] : []
    },
    showMetrics() {
      return this.metricsRange.case({
        Just: () => true,
        Nothing: () => false,
      })
    },
    reportChartData() {
      let that = this
      return {
        credits: {
          enabled: false,
        },
        chart: {
          type: 'bar',
          margin: [100, 80, 100, 390],
          spacingTop: 20,
          spacingLeft: 0,
          spacingRight: 15,
          spacingBottom: 10,
          style: {
            fontFamily: '"OpenSansRegular", Arial',
          },
          events: {
            load: function() {
              defaultSelect(this)
              drawChartInfoOnFoot(this, that)
              setChartSize(this, that)
              initEventOfCustomLegend(this, that)
            },
          },
        },
        colors: that.colors,
        exporting: {
          allowHTML: true,
          buttons: {
            contextButton: {
              symbol: 'download',
              menuItems: [
                {
                  text: 'Download JPEG image',
                  onclick: function() {
                    this.exportChart(
                      {
                        type: 'image/jpeg',
                      },
                      {
                        series: that.assembleSeries(
                          that.defaultDemographic,
                          that.metrics
                        ),
                        subtitle: {
                          x: 0
                        }
                      }
                    )
                  },
                },
              ],
            },
          },
        },
        legend: {
          enabled: false
        },
        title: {
          style: { fontWeight: 'bold' },
          text: that.chartType,
        },
        subtitle: {
          align: 'center',
          useHTML: true,
          text: that.preparedData.SubTitle,
        },
        xAxis: {
          categories: that.preparedData.Categories,
          crosshair: true,
          gridLineWidth: 1,
          tickColor: '#e6e6e6',
          tickLength: 340,
          labels: {
            align: 'left',
            style: {
              fontSize: '14px',
              width: 170,
            },
            x: -340,
            useHTML: true,
            formatter: function() {
              let top =
                -this.chart.plotHeight / this.axis.categories.length / 2 + 23
              let frontHtml =
                '<div style="position:relative;"><span style="top:' +
                top +
                'px;position:absolute;font-weight:bolder;font-size:20px;">'
              if (this.value === this.axis.categories[0]) {
                frontHtml =
                  frontHtml + that.preparedData.Selection1 + '</span></div>'
              } else if (this.value === this.axis.categories[1]) {
                frontHtml =
                  frontHtml + that.preparedData.Selection2 + '</span></div>'
              } else {
                frontHtml = ''
              }
              let xLabelWhenMetrics =
                that.selectedMetrics.length > 1
                  ? '<div style="width:340px;display:flex;align-items:center;"><div style="width:170px;display:inline-block;"><span>' +
                    this.value +
                    '</span></div><div style="width:170px;display:inline-block;text-align:right;"><span style="font-size:12px;">' +
                    that.getDemographicMapName(that.defaultDemographic) +
                    '&nbsp;&nbsp;</span></div></div>'
                  : this.value
              return frontHtml + xLabelWhenMetrics
            },
          },
        },
        yAxis: {
          gridLineWidth: 0,
          min: 0,
          labels: {
            formatter: function() {
              return this.value * 100 + '%'
            },
          },
          title: {
            text: null,
          },
          opposite: true,
          tickPositions: [0, 0.2, 0.4, 0.6, 0.8, 1.0],
        },
        plotOptions: {
          series: {
            minPointLength: 3,
            dataLabels: {
              enabled: true,
              crop: false,
              overflow: 'allow',
              inside: false,
              useHTML: true,
              formatter: function() {
                var colorString = this.color
                var val = Math.round(this.y * 100)
                var left = -180 - this.point.shapeArgs.height
                var leftLabelName =
                  that.selectedMetrics.length > 1
                    ? ''
                    : that.getDemographicMapName(this.series.name)
                return (
                  "<span style='color: " +
                  colorString +
                  "'>" +
                  (val ? val + '%' : 'N/A') +
                  '</span>' +
                  "<span style='overflow:hidden;width:170px;display:inline-block;text-align:right;color:#666666;font-weight:normal;position:absolute;left:" +
                  left +
                  "px'>" +
                  leftLabelName +
                  '</span>'
                )
              },
            },
            pointPadding: 0.1,
            pointWidth: 14,
            groupPadding: 0.05,
          },
        },
        tooltip: {
          enabled: false,
        },
        series: that.assembleSeries(that.defaultDemographic, that.metrics),
      }
    },
    ...mapState('wizard', {
      chartType: state => {
        return state.chartType[0] ? state.chartType[0].displayText() : ''
      },
      selectedMetrics(state) {
        return R.map(m => m[0], state.metrics[0] || [])
      },
      /**
       * @param {Wizard} state
       */
      wizardPreviousRoute(state) {
        return state.metrics.case({
          Nothing: () =>
            state.chartSelection.map(cSelection =>
              cSelection.case({
                StateVsRegions: () => '/dataViz/wizard/choose-regions',
                Regions: () => '/dataViz/wizard/choose-regions',
                RegionVsDistricts: () => '/dataViz/wizard/choose-districts',
                Districts: () => '/dataViz/wizard/choose-districts',
                DistrictVsCampuses: () => '/dataViz/wizard/choose-campuses',
                Campuses: () => '/dataViz/wizard/choose-campuses',
              })
            ),
          Just: () => Maybe.of('/dataViz/wizard/choose-data-categories'),
        })[0]
      },
      searchOption(state) {
        var opt = {}
        opt.SchoolYear = this.transformYear(this.selectedYears)
        opt.Metrics = this.selectedMetrics
        opt.Properties = [
          { Type: 'none', Value: 'all' },
          { Type: 'race', Value: 'white' },
          { Type: 'race', Value: 'asian' },
          { Type: 'race', Value: 'afra' },
          { Type: 'race', Value: 'afri' },
          { Type: 'race', Value: 'two' },
          { Type: 'race', Value: 'pacific' },
          { Type: 'race', Value: 'hispanic' },
          { Type: 'gender', Value: 'male' },
          { Type: 'gender', Value: 'female' },
          { Type: 'ell', Value: 'ell' },
          { Type: 'ell', Value: 'at_risk' },
          { Type: 'econo_disadv', Value: 'low_income' },
        ]

        opt.Subjects = R.map(
          sub => sub.id,
          state.chartSelection.map(cSelection =>
            cSelection.case({
              StateVsRegions: (s, rs) => R.concat([{ id: 'TX' }], rs[0]),
              Regions: rs => rs[0],
              RegionVsDistricts: (r, ds) => R.concat([r[0]], ds[0]),
              Districts: ds => ds[0],
              DistrictVsCampuses: (d, cs) => R.concat([d[0]], cs[0]),
              Campuses: cs => cs[0],
            })
          )[0]
        )

        return opt
      },
    }),

    ...mapGetters('wizard', ['metricsRange']),
    ...mapState('misc', ['schoolYears']),
  },
  ...mapState('wizard', {
    created(state) {
      this.schoolYears.then(data => {
        this.years = R.take(3, data || []);
        this.selectedYears = R.nth(0, this.years) || (throw new Error('no school years data'))
      })
      this.isRenderingChart = true
    },
  }),
  watch: {
    selectedYears(newValue, oldValue) {
      this.getChartDatas()
    },
    defaultDemographic(newValue, oldValue) {
      this.updateFooter()
    },
    metrics: {
      handler(newValue, oldValue) {
        if (!reportChart.update) {
          return
        }
        reportChart.update(
          {
            series: this.assembleSeries(this.defaultDemographic, newValue),
          },
          true,
          true,
          false
        )
      },
      deep: true,
    },
    schoolYears(schoolYearSearchResult) {
      schoolYearSearchResult.then(data => {
        this.years = R.take(3, data || []);
        this.selectedYears = R.nth(0, this.years) || (throw new Error('no school years data'))
      })
    },
  },
  methods: {
    initYears() {
      let thisYear = new Date().getFullYear()
      return [
        thisYear - 1 + '-' + thisYear,
        thisYear - 2 + '-' + (thisYear - 1),
        thisYear - 3 + '-' + (thisYear - 2),
      ]
    },
    transformYear(year) {
      if (year.length === 5) {
        return R.map(s => '20' + s, year.split('-')).join('-')
      }
      return R.map(s => R.slice(2, 4, s), year.split('-')).join('-')
    },
    updateFooter() {
      if (reportChart.chartFooter) {
        reportChart.chartFooter.destroy()
        drawChartInfoOnFoot(reportChart, this)
      }
    },
    reset(){
      if(!reportChart || !reportChart.update){
        return
      }
      let newSeries = R.map(s => {
        return { name: s.name, data: s.yData, visible: s.name === 'All Students' }
      }, reportChart.series)
      reportChart.update(
        {
          series: newSeries,
        },
        true,
        true,
        false
      )
      this.updateFooter()
      setChartSize(reportChart, this)
    },
    getDemographicMapName(demographic) {
      let index = R.findIndex(x => x === demographic, this.demographics)
      return this.demographicsMap[index]
    },
    demographicsOnFooter() {
      if (this.selectedMetrics.length < 2) {
        let demographics = R.filter(v => v.checked, this.demographicOptions)
        if (demographics.length === 0) {
          return '<br/>Demographic: '
        } else if (demographics.length === 1) {
          return (
            '<br/>Demographic: <b>' +
            this.getDemographicMapName(demographics[0].label) +
            '</b>'
          )
        } else {
          return (
            '<br/>Demographics: <b>Multiple Values (' +
            demographics.length +
            ')</b>'
          )
        }
      } else {
        return (
          '<br/>Demographic: <b>' +
          this.getDemographicMapName(this.defaultDemographic) +
          '</b>'
        )
      }
    },
    selectDemographic(demographic) {
      this.defaultDemographic = demographic
      if (reportChart.update) {
        reportChart.update(
          {
            series: this.assembleSeries(demographic, this.metrics),
          },
          true,
          true,
          false
        )
      }
    },
    selectAllOrNone(all) {
      _forEach(seriesDataIds, item => {
        var series = reportChart.get(item.id)
        if (all) {
          series.setVisible(true)
        } else {
          series.setVisible(false)
        }
      })
      setChartSize(reportChart, this)
    },
    /**
     * @param {Wizard} state
     */
    transformResponse(state, response) {
      let that = this
      let filledMetricDatas = R.map(sm => {
        return {
          states: [],
          regions: [],
          districts: [],
          campuses: [],
          metric: sm,
        }
      }, that.selectedMetrics)

      if (that.selectedMetrics.length === 0) {
        filledMetricDatas = [
          {
            states: [],
            regions: [],
            districts: [],
            campuses: [],
            metric: null,
          },
        ]
      }

      let fillObj = (id, name) => {
        return {
          id: id,
          name: name,
          data: R.map(x => 0, R.indexBy(dg => dg, that.demographics)),
        }
      }

      let wizardTrans = function(k1, v1, k2, v2) {
        let sub1 = null
        if (!R.isNil(v1)) {
          sub1 = Maybe.valueOrDefault({}, v1)
        }
        let sub2 = Maybe.valueOrDefault([], v2)

        return R.map(v => {
          let mData = R.find(md => md.metric === v.metric, response.metricDatas)
          if (sub1 != null) {
            if (mData[k1].length === 0) {
              v[k1].push(fillObj(sub1.id, sub1.name))
            } else {
              v[k1] = mData[k1]
            }
          }

          R.forEach(sd => {
            let dData = R.find(dd => dd.id === sd.id, mData[k2])
            if (R.isNil(dData)) {
              v[k2].push(fillObj(sd.id, sd.name))
            } else {
              v[k2].push(dData)
            }
          }, sub2)
          return v
        }, filledMetricDatas)
      }

      state.chartSelection.map(cSelection =>
        cSelection.case({
          StateVsRegions: (s, rs) => {
            filledMetricDatas = wizardTrans('states', s, 'regions', rs)
          },
          Regions: rs => {
            filledMetricDatas = wizardTrans(null, null, 'regions', rs)
          },
          RegionVsDistricts: (r, ds) => {
            filledMetricDatas = wizardTrans('regions', r, 'districts', ds)
          },
          Districts: ds => {
            filledMetricDatas = wizardTrans(null, null, 'districts', ds)
          },
          DistrictVsCampuses: (d, cs) => {
            filledMetricDatas = wizardTrans('districts', d, 'campuses', cs)
          },
          Campuses: cs => {
            filledMetricDatas = wizardTrans(null, null, 'campuses', cs)
          },
        })
      )

      response.metricDatas = R.map(res => {
        res.states = R.map(v => {
          v.data = R.map(d => (d ? (d / 100).toFixed(3) : 0), v.data)
          return v
        }, res.states || [])
        res.regions = R.map(v => {
          v.data = R.map(d => (d ? (d / 100).toFixed(3) : 0), v.data)
          return v
        }, R.sortBy(R.prop('id'), res.regions || []))
        res.districts = R.map(v => {
          v.data = R.map(d => (d ? (d / 100).toFixed(3) : 0), v.data)
          return v
        }, R.sortBy(R.prop('name'), res.districts || []))
        res.campuses = R.map(v => {
          v.data = R.map(d => (d ? (d / 100).toFixed(3) : 0), v.data)
          return v
        }, R.sortBy(R.prop('name'), res.campuses || []))
        return res
      }, filledMetricDatas)

      return response
    },
    assembleSeries(demographic, newMetrics) {
      let series = []
      if (
        !this.responseData.metricDatas ||
        this.responseData.metricDatas.length === 0
      ) {
        return series
      }
      let metricDatas = this.responseData.metricDatas[0]
      let chartDataConcat = v =>
        R.concat(
          R.concat(v.states, v.regions),
          R.concat(v.districts, v.campuses)
        )
      if (this.selectedMetrics.length < 2) {
        R.forEach(v => {
          let obj = { name: v.label, data: [], visible: v.checked }
          R.forEach(d => {
            obj.data.push(parseFloat(R.defaultTo(0, d.data[v.label])))
          }, chartDataConcat(metricDatas))
          series.push(obj)
        }, this.demographicOptions)
      } else {
        let that = this
        let waitingForeach = R.filter(
          m =>
            R.find(s => s.label === m.metric && s.checked, newMetrics) !==
            undefined,
          that.responseData.metricDatas
        )
        waitingForeach = R.sort(function(a, b) {
          a = R.findIndex(x => x.label === a.metric, that.metrics)
          b = R.findIndex(x => x.label === b.metric, that.metrics)
          return a - b
        }, waitingForeach)

        R.forEach(v => {
          let obj = { name: demographic, data: [], visible: true }
          let index = R.findIndex(c => c.label === v.metric, that.metrics)
          if (index > -1) {
            obj.color = that.colors[index]
          }
          R.forEach(d => {
            obj.data.push(parseFloat(R.defaultTo(0, d.data[demographic])))
          }, chartDataConcat(v))
          series.push(obj)
        }, waitingForeach)
      }
      return series
    },
    ...mapState('wizard', {
      getIntroComp(state) {
        return state.chartType[0].introComp()
      },
      /**
       * @param {Wizard} state
       */
      getChartDatas(state) {
        let that = this
        let requestUrl = state.chartType[0].requestUrl()
        that.isRenderingChart = true
        this.schoolYears.then(() => {
          getChartData(this.searchOption, requestUrl).then(val => {
            that.responseData = that.transformResponse(state, val)
            let pData = {}
            let multiSpaces = '\u00a0\u00a0\u00a0'
            pData.schoolYear = that.responseData.schoolYear
            pData.schoolYearLong = this.transformYear(pData.schoolYear)
            state.chartSelection.map(cSelection =>
              cSelection.case({
                StateVsRegions: (s, rs) => {
                  pData.Selection1 = 'State'
                  pData.Selection2 = 'Region'
                  pData.Categories = []
                  pData.SubTitle = 'State: <b>Texas</b>'
                  s.map(v => {
                    pData.Categories.push('Texas')
                  })
                  rs.map(v => {
                    pData.Categories = R.concat(
                      pData.Categories,
                      R.pluck('name', v)
                    )
                    pData.SubTitle +=
                      multiSpaces +
                      'Region: <b>' +
                      (v.length > 1
                        ? 'Multiple Values (' + v.length + ')'
                        : v[0].name) +
                      '</b>'
                  })
                },
                Regions: rs => {
                  pData.Selection1 = 'Region'
                  pData.Selection2 = ''
                  pData.Categories = []
                  rs.map(v => {
                    pData.Categories = R.pluck('name', v)
                    pData.SubTitle =
                      'Region: <b>' +
                      (v.length > 1
                        ? 'Multiple Values (' + v.length + ')'
                        : v[0].name) +
                      '</b>'
                  })
                },
                RegionVsDistricts: (r, ds) => {
                  pData.Selection1 = 'Region'
                  pData.Selection2 = 'District'
                  pData.Categories = []
                  r.map(v => {
                    pData.Categories.push(v.name)
                    pData.SubTitle = 'Region: <b>' + v.name + '</b>'
                  })
                  ds.map(v => {
                    pData.Categories = R.concat(
                      pData.Categories,
                      R.pluck('name', v)
                    )
                    pData.SubTitle +=
                      multiSpaces +
                      'District: <b>' +
                      (v.length > 1
                        ? 'Multiple Values (' + v.length + ')'
                        : v[0].name) +
                      '</b>'
                  })
                },
                Districts: ds => {
                  pData.Selection1 = 'District'
                  pData.Selection2 = ''
                  pData.Categories = []
                  ds.map(v => {
                    pData.Categories = R.pluck('name', v)
                    pData.SubTitle =
                      'District: <b>' +
                      (v.length > 1
                        ? 'Multiple Values (' + v.length + ')'
                        : v[0].name) +
                      '</b>'
                  })
                },
                DistrictVsCampuses: (d, cs) => {
                  pData.Selection1 = 'District'
                  pData.Selection2 = 'Campus'
                  pData.Categories = []
                  d.map(v => {
                    pData.Categories.push(v.name)
                    pData.SubTitle = 'District: <b>' + v.name + '</b>'
                  })
                  cs.map(v => {
                    pData.Categories = R.concat(
                      pData.Categories,
                      R.pluck('name', v)
                    )
                    pData.SubTitle +=
                      multiSpaces +
                      'Campus: <b>' +
                      (v.length > 1
                        ? 'Multiple Values (' + v.length + ')'
                        : v[0].name) +
                      '</b>'
                  })
                },
                Campuses: cs => {
                  pData.Selection1 = 'Campus'
                  pData.Selection2 = ''
                  pData.Categories = []
                  cs.map(v => {
                    pData.Categories = R.pluck('name', v)
                    pData.SubTitle =
                      'Campus: <b>' +
                      (v.length > 1
                        ? 'Multiple Values (' + v.length + ')'
                        : v[0].name) +
                      '</b>'
                  })
                },
              })
            )
            pData.SubTitle +=
              multiSpaces + 'Year: <b>' + pData.schoolYearLong + '</b>'
            that.preparedData = pData
            that.isRenderingChart = false
            refreshDataLabels()
            if (that.metrics.length > 0) {
              if (!reportChart.update) {
                return
              }
              let subtitleWidth = reportChart.subtitle.getBBox().width
              reportChart.update(
                {
                  series: that.assembleSeries(
                    that.defaultDemographic,
                    that.metrics
                  ),
                  subtitle: {
                    text: that.preparedData.SubTitle,
                    x: -subtitleWidth / 2, // be aimed at making the subtitle displayed center
                  },
                },
                true,
                true,
                false
              )

              that.updateFooter()
              return
            }
            that.metrics = _map(that.metricsOptions, (val, index) => {
              return {
                label: val,
                id: 'metric-item-' + index,
                checked: R.any(m => m === val, that.selectedMetrics),
                disabled: R.all(m => m !== val, that.selectedMetrics),
              }
            })
            seriesDataIds = that.demographicOptions
            _forEach(that.reportChartData.series, (item, index) => {
              item.id = seriesDataIds[index].id
            })
            that.reportChartData.colors = that.colors
            reportChart = HighCharts.chart('report-chart', that.reportChartData)
          })
        })
      }
    }),
    toPreviousPage() {
      this.$router.push({ path: this.wizardPreviousRoute })
    },
  },
}
</script>

<template>
  <v-layout column>
    <v-layout row>
      <v-flex
        class="top-line bottom-line"
        d-inline-flex>
        <v-list class="toolbar-top">
          <v-list-tile>
            <v-list-tile-action>
              <v-btn
                aria-label="landing page return"
                icon
                class="mt-0 mb-0 app-icon-content"
                to="/dataViz">
                <v-icon
                  style="color: #243f92"
                  large>apps</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="report-name">
                {{ chartType }}
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="600"
                  :max-width="600"
                  offset-x
                  offset-y
                  class="info-btn"
                >
                  <v-btn
                    slot="activator"
                    :aria-label="chartType"
                    icon
                    class="ml-0 mt-0 mb-0 mr-0">
                    <v-icon>info</v-icon>
                  </v-btn>
                  <component :is="getIntroComp()" />
                </v-menu>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex
        v-show="!isRenderingChart"
        xs3>
        <v-layout column>
          <v-flex
            class="top-line right-line">
            <div>
              <div
                class="edit-chart-options bottom-line pl-3"
                @click="toPreviousPage">
                <span>
                  <v-icon
                    class="mr-2"
                    style="color: #757575">arrow_back</v-icon>Edit Chart Options
                </span>
              </div>
              <div class="pl-5 pr-4">
                <ReportsFilter
                  v-if="selectedMetrics.length < 2"
                  :colors="colors"
                  :demographics="demographicOptions"
                  :demographics-map="demographicsMap"
                  class="multi-checkboxes"
                  @selectAll="selectAllOrNone(true)"
                  @selectNone="selectAllOrNone(false)"
                  @updateFooter="updateFooter()"
                  @reset="reset()"
                />
                <ReportsSingleFilter
                  v-if="selectedMetrics.length > 1"
                  :options="demographicOptions"
                  :demographics-map="demographicsMap"
                  @selectDemographic="selectDemographic"
                />
                <v-divider
                  v-if="selectedMetrics.length > 0"
                  class="mt-2 mb-2"/>
                <ReportsMetrics
                  v-if="selectedMetrics.length > 1"
                  :colors="colors"
                  :metrics="metrics"
                  @updateFooter="updateFooter()"
                />
                <ReportsSingleMetric
                  v-if="selectedMetrics.length === 1"
                  :metrics="metrics"/>
                <v-divider class="mt-2 mb-2"/>
                <v-list class="mb-4 year-select">
                  <v-list-tile avatar>
                    <v-list-tile-title class="year-title">Year</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-select
                        :items="years"
                        v-model="selectedYears"
                        append-icon="keyboard_arrow_down"
                        class="custom-select"
                        aria-expanded="false"
                      />
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <Loading
        v-if="isRenderingChart"
        class="fix-high"/>
      <v-flex
        v-show="!isRenderingChart"
        xs9
        d-inline-flex>
        <div>
          <div id="report-chart"/>

          <div
            id="TAPR"
            style="margin: 1em 5em 1em 5em;">
            *TAPR - The Texas Academic Performance Reports (TAPR) are reports pulled together by TEA which present a wide range of information on the
            performance of students in each school and district in Texas every year. Performance is shown disaggregated by student groups,
            including ethnicity and socioeconomic status. The reports also provide extensive information on school and district staff, programs,
            and student demographics.
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<style scoped>
#TAPR {
  visibility: hidden;
}
.toolbar-top >>> .list__tile__action {
  min-width: 32px;
}
.app-icon-content >>> .btn__content {
  color: rgba(255, 255, 255, 1);
}
.report-name {
  font-size: 20px;
  overflow: visible;
  height: 36px;
  line-height: 36px;
}
.edit-chart-options {
}
.edit-chart-options:hover {
  cursor: pointer;
}
.edit-chart-options >>> span {
  font-size: 16px;
  line-height: 35px;
  display: inline-block;
  text-align: center;
}
.top-line {
  border-top: 1px solid #e6e6e6;
}
.bottom-line {
  border-bottom: 1px solid #e6e6e6;
}
.right-line {
  border-right: 1px solid #e6e6e6;
}
.info-btn >>> .btn__content {
  color: #253e90;
}
.info-btn >>> .btn__content::before {
  color: #0390c4;
  opacity: 0.5;
}
td {
  text-align: center;
}
</style>

<style scoped>
.year-title {
  font-weight: bolder;
  font-size: 16px;
  color: #707070;
  padding: 0;
}
.year-select >>> .list__tile {
  padding: 0;
}
.year-select >>> .list__tile--avatar {
  height: 40px;
}
.year-select >>> .custom-select > .input-group__input {
  border: 1px solid #ccc;
  max-width: 100%;
}
.year-select >>> .custom-select > .input-group__details {
  display: none;
}
.year-select
  >>> .custom-select
  > .input-group__input
  > .input-group__selections {
  padding-left: 10px;
}
.year-select >>> .input-group {
  padding: 0;
}
.year-select >>> .list__tile__content {
  flex-direction: row;
}
.fix-high {
  height: 500px;
}
</style>
